export const TOLGEE_REMOTE_ENABLED = false;

export const tolgeeApiUrl = TOLGEE_REMOTE_ENABLED ? process.env.NEXT_PUBLIC_TOLGEE_API_URL : undefined;

export const tolgeeApiKey = TOLGEE_REMOTE_ENABLED ? process.env.NEXT_PUBLIC_TOLGEE_API_KEY : undefined;
